import type { StaticLayerPayload } from "@config";
import { CollapsibleLibrary } from "@library-elements/collapsible-text";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: CollapsibleLibrary,
};

export const CollapsibleText = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
